import React from "react";
import Divider from "./Divider";
import { ShimmerTitle } from './Shimmer'; 
import PropTypes from 'prop-types';
import Event from "../models/Event";

const propTypes = {
    event: PropTypes.object,
    isLoaded: PropTypes.bool
}

const defaultProps = {
    event: new Event(),
    isLoaded: false
}

const TableEvent = ({...props}) => {
    return (
        <div className="c">
            <table className="table no-border">
                <thead>
                    <tr>
                        <th colSpan={2}>
                            {props.isLoaded ?
                                <h4 className="text-uppercase"><b>{props.event.title}</b></h4>
                            :
                            <ShimmerTitle line={2} gap={10} variant="primary" />
                            }
                            <Divider />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{width: '2rem'}}><b>Fechas:</b></td>
                        <td>
                            {props.isLoaded ? <>{props.event.startDate}</> : <ShimmerTitle line={1} />}
                        </td>
                    </tr>
                    <tr>
                        <td><b>Horario:</b></td>
                        <td>{props.isLoaded ? <>{props.event.startTime}</> : <ShimmerTitle line={1} />}</td>
                        {/* <td>{props.isLoaded ? <>{props.event.startTime} - {props.event.endTime}</> : <ShimmerTitle line={1} />}</td> */}
                    </tr>
                    <tr>
                        <td><b>Lugar:</b></td>
                        <td>{props.isLoaded ? props.event.location : <ShimmerTitle line={1} />}</td>
                    </tr>
                    <tr>
                        <td><b>Donativo + comisión de plataforma:</b></td>
                        <td>{props.isLoaded ? <>$ {props.event.price}</> : <ShimmerTitle line={1} />}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

TableEvent.propTypes = propTypes;
TableEvent.defaultProps = defaultProps;

export default TableEvent;